export default (function (siteVars) {
  return {
    disabledColor: siteVars.colors.black,
    disabledBackgroundColor: siteVars.accessibleGreen
  };
});